import React from 'react';

/**
 * Liedzeit-Section-Header: Großbuchstaben-Eyebrow in Bernstein,
 * Serif-Titel, kurze Bernstein-Linie. `onBrand` für dunkle Navy-Bänder.
 */
export default function SectionHeading({ eyebrow, title, subtitle, onBrand = false, align = 'center' }) {
  const alignCls = align === 'center' ? 'text-center items-center' : 'text-left items-start';
  return (
    <div className={`flex flex-col ${alignCls}`}>
      {eyebrow && (
        <p className={`text-xs font-bold uppercase tracking-eyebrow mb-3 ${onBrand ? 'text-amber-300' : 'text-amber-700'}`}>
          {eyebrow}
        </p>
      )}
      {title && (
        <h2 className={`font-serif font-bold ${onBrand ? 'text-white' : 'text-stone-900'}`}>
          {title}
        </h2>
      )}
      <div className={`w-16 h-1 mt-4 ${onBrand ? 'bg-amber-400' : 'bg-amber-600'} ${align === 'center' ? 'mx-auto' : ''}`} />
      {subtitle && (
        <p className={`mt-5 max-w-2xl text-lg font-light ${onBrand ? 'text-stone-300' : 'text-stone-500'}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
